module.exports = __webpack_public_path__ + "assets/img/gr-yes.4bcedd2b.png";